const selectProviders = () => {
    const feedbackModal = document.getElementById('review-modal');
    const ratingMainItems = document.querySelectorAll('#review-desktop');

    ratingMainItems.forEach(el => {
        const button = el.querySelector('.open-provider-review');
        button.addEventListener('click', () => {
            document.querySelectorAll('.open-provider-review').forEach(btn => {
                btn.classList.remove('selected');
            });

            button.classList.add('selected');

            openReviewModal('.open-provider-review.selected');
        });
    })

    const openReviewModal = (provider) => {

    }
}

const loadMoreReviews = () => {
    const reviewsContainer = document.getElementById('address-reviews-container');
    const allProviders = JSON.parse(reviewsContainer.dataset.providers);

    document.querySelectorAll('.address-reviews__filter-item').forEach(filter => {
        filter.addEventListener('click', function () {
            const selectedProvider = this.dataset.provider || null;

            updateActiveFilter(this);

            loadReviews(1, selectedProvider, allProviders);
        });
    });

    loadReviews(1, null, allProviders);
}

function updateActiveFilter(activeElement) {
    document.querySelectorAll('.address-reviews__filter-item').forEach(el => {
        el.classList.remove('active');
    });
    activeElement.classList.add('active');
}

function loadReviews(page, selectedProvider, allProviders) {
    const container = document.getElementById('address-reviews-container');
    const loadMoreBtn = document.getElementById('load-more-reviews');

    if (loadMoreBtn) {
        loadMoreBtn.disabled = true;
    }

    fetch('/load-house-reviews', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({
            page: page,
            selected_provider: selectedProvider,
            all_providers: allProviders,
            chunk_url: container.dataset.chunkUrl
        })
    })
        .then(response => response.json())
        .then(data => {
            if (page === 1) {
                container.innerHTML = data.html;
            } else {
                container.insertAdjacentHTML('beforeend', data.html);
            }
            initReviewsRating();
            updateLikesView();
            updateLoadMoreButton(data.next_page, selectedProvider);
            initLikeButtonsEvents();
        });
}

function initReviewsRating() {
    const ratings = document.querySelectorAll(".address-reviews .js_raiting");

    ratings.forEach((element) => {
        let num = element.dataset.num;
        let size_p = 20.5;

        if (num) {
            let rating = num * size_p;
            element.querySelector(".stars_over_bg").style.width =
                rating + "%";
        }
    });
    /*кастомные звезды для карточки провайдера*/
    const ratingElements = document.querySelectorAll('.providers-card_js_raiting');
    ratingElements.forEach(element => {
        const rating = parseFloat(element.getAttribute('data-num'));
        const starsOverBg = element.querySelector('.providers-card_stars_over_bg');
        const widthPercent = (rating / 5) * 97;
        starsOverBg.style.width = widthPercent + '%';
    });
}

function updateLoadMoreButton(nextPage, selectedProvider) {
    const loadMoreBtn = document.getElementById('load-more-reviews');

    if (!loadMoreBtn) {
        return;
    }

    if (nextPage) {
        loadMoreBtn.dataset.page = nextPage;
        loadMoreBtn.dataset.provider = selectedProvider || '';
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = 'Показать больше отзывов';

        loadMoreBtn.style.display = '';

        loadMoreBtn.onclick = function () {
            const container = document.getElementById('address-reviews-container');
            const allProviders = container ? JSON.parse(container.dataset.providers || '[]') : [];
            loadReviews(this.dataset.page, this.dataset.provider || null, allProviders);
        };
    } else {
        loadMoreBtn.style.display = 'none';
    }
}

function handleVote(button, voteType) {
    const reviewItem = button.closest('.address-reviews__wrapper-item');
    const reviewId = reviewItem.dataset.reviewId;

    const votedReviews = JSON.parse(localStorage.getItem('votedReviews') || '{}');

    if (votedReviews[reviewId]) {
        if (votedReviews[reviewId] === voteType) {
            const increment = (voteType === 'like') ? -1 : 1;
            updateVote(reviewId, voteType, increment, false, true);
        } else {
            const increment = (voteType === 'like') ? 2 : -2;
            updateVote(reviewId, voteType, increment, true);
        }
        return;
    }

    const increment = voteType === 'like' ? 1 : -1;
    updateVote(reviewId, voteType, increment, false);
}

let isVoteInProgress = false;

function updateVote(reviewId, voteType, increment, isChange, isCancel = false) {
    if (isVoteInProgress) return;
    isVoteInProgress = true;

    const reviewItem = document.querySelector(`[data-review-id="${reviewId}"]`);
    const likesCountEl = reviewItem.querySelector('.likes-count');

    fetch('/reviews/' + reviewId + '/vote', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
            vote: voteType,
            is_change: isChange,
            is_cancel: isCancel,
        })
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                if (likesCountEl) {
                    const currentCount = parseInt(likesCountEl.textContent);
                    const count = currentCount + increment;
                    likesCountEl.textContent = '+' + count;
                }

                const votedReviews = JSON.parse(localStorage.getItem('votedReviews') || "{}");

                if (isCancel) {
                    delete votedReviews[reviewId];
                } else if (isChange || voteType) {
                    votedReviews[reviewId] = voteType;
                } else {
                    delete votedReviews[reviewId];
                }
                localStorage.setItem('votedReviews', JSON.stringify(votedReviews));

                updateButtonStates(reviewItem, voteType, isCancel);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        })
        .finally(() => {
            setTimeout(() => {
                isVoteInProgress = false;
            }, 300);
        });
}

function initLikeButtonsEvents() {
    document.querySelectorAll('.like-button').forEach(button => {
        button.addEventListener('click', function () {
            handleVote(this, 'like');
        });
    });

    document.querySelectorAll('.dislike-button').forEach(button => {
        button.addEventListener('click', function () {
            handleVote(this, 'dislike');
        });
    });
}

function updateButtonStates(reviewItem, voteType, isCancel = false) {
    const likeBtn = reviewItem.querySelector('.like-button');
    const dislikeBtn = reviewItem.querySelector('.dislike-button');

    likeBtn && likeBtn.classList.remove('active');
    dislikeBtn && dislikeBtn.classList.remove('active');

    if (!isCancel) {
        if (voteType === 'like') {
            likeBtn.classList.add('active');
        } else if (voteType === 'dislike') {
            dislikeBtn.classList.add('active');
        }
    }

}

function updateLikesCount(reviewItem, voteType) {
    const likesCount = reviewItem.querySelector('.likes-count');

    let count = parseInt(likesCount.dataset.likes) || 0;

    if (voteType === 'like') {
        count++;
    } else if (voteType === 'dislike') {
        count--;
    }

    likesCount.textContent = count > 0 ? '+' + count : count.toString();
    likesCount.dataset.likes = count;

}

function updateLikesView() {
    const votedReviews = JSON.parse(localStorage.getItem('votedReviews') || '{}');

    Object.keys(votedReviews).forEach(reviewId => {
        const reviewItem = document.querySelector(`[data-review-id="${reviewId}"]`);
        if (reviewItem) {
            updateLikesCount(reviewItem, votedReviews[reviewId]);
            updateButtonStates(reviewItem, votedReviews[reviewId]);
        }
    });
}

function initReview() {
    // На новом дизайне адреса отзывы инициализирует address-v2/reviews.js
    if (document.body.classList.contains('address-theme--v2')) {
        return;
    }

    const reviewsContainer = document.getElementById('address-reviews-container');
    if (reviewsContainer) {
        loadMoreReviews();
        updateLikesView();
        selectProviders();
        initLikeButtonsEvents();
    }
}

document.addEventListener('DOMContentLoaded', initReview);
